import * as React from 'react';
import classNames from 'classnames';
import './strikeThrough.module.scss';

type Props = {
    lineColor: 'gray';
    children: any;
    className?: string;
    styleName?: string;
};

export const StrikeThrough = ({ children, lineColor = 'gray', className = undefined }: Props) => {
    return (
        <div styleName={classNames('strike-through', lineColor)} className={className}>
            {children}
            <div styleName={classNames('line', lineColor)} />
        </div>
    );
};
